import type { ServerConfiguration } from '@/domain/configuration';
import { chatServiceDomain } from '@/lib/chatServiceDomain';

export function getAnalyticsEndpoint(serverConfig: ServerConfiguration): string {
  if (serverConfig.gladlyStage === 'development') return 'http://localhost:3300';
  return `https://analytics.${chatServiceDomain(serverConfig.gladlySite)}`;
}
